// extracted by mini-css-extract-plugin
module.exports = {"container":"MobileForm_container__jl9WE","header":"MobileForm_header__qtnXv"};